import ChimeKitIcon from 'components/shared/LinkWithIcon/ChimeKitIcon';
import Media from 'components/shared/Media/Media';
import NavLink from 'components/shared/NavLink/NavLink';
import { NavSubLinkProps } from './types';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { generateIdSegmentFromLink } from 'components/MainNav/utils';

interface MainNavSubLinkProps extends NavSubLinkProps {
  idPrefix: string;
}

const NavSubLink = ({ description, link, chimeKitIconName, icon, idPrefix }: MainNavSubLinkProps) => {
  const { sys, label, url, internalPage } = link;
  const showIcon = chimeKitIconName != null;
  const subLinkIdSegment = generateIdSegmentFromLink(link);

  return (
    <NavLink
      id={`${idPrefix}_${subLinkIdSegment}`}
      href={url}
      internalPage={internalPage}
      level={1}
      cleanLinkText={label}
      className="active:scale-none group hover:text-current">
      <div className={cn('flex gap-2', !description && 'items-center')}>
        <div className="w-6 flex-none">
          {showIcon && <ChimeKitIcon iconName={chimeKitIconName} />}
          {icon && <Media media={{ ...icon, width: 24, height: 24 }} className="w-full" />}
        </div>

        <div className="flex flex-col ml-2">
          <p
            className="font-sans text-label-saans font-semibold group-hover:text-fern group-focus:text-fern"
            {...liveUpdateAttrs(sys?.id, 'label')}>
            {label}
          </p>
          {description && (
            <p className="font-serif text-sm" {...liveUpdateAttrs(sys?.id, 'description')}>
              {description}
            </p>
          )}
        </div>
      </div>
    </NavLink>
  );
};

export default NavSubLink;
